import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 全局组测
import './utils/global.js';
import Cookies from 'js-cookie'
Vue.prototype.$cookies = Cookies;
// iconify-icon 是 Web Component，避免 Vue2 报 Unknown custom element
Vue.config.ignoredElements = ['iconify-icon']
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
